import { useContext, type ReactElement } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { ODSButton, ODSGroup } from 'bc-ods';
import MatchingAccountCard from './MatchingAccountCard';
import {
  SmartLoginStateContext,
  SmartLoginActionsContext,
  FormStepEnum,
} from './context/SmartLoginContextProvider';

const messages = defineMessages({
  heading: {
    id: 'SSOLinkSuccess.heading',
    defaultMessage: 'Account linked successfully',
  },
  body: {
    id: 'SSOLinkSuccess.body',
    defaultMessage:
      'Your SSO identity has been linked to your Onebrief account. All your plans, organizations, and collaboration history are intact.',
  },
  continue: {
    id: 'SSOLinkSuccess.continue',
    defaultMessage: 'Continue to Onebrief',
  },
});

function SSOLinkSuccess(): ReactElement {
  const { profile, discoveredAccountDetails } = useContext(SmartLoginStateContext);
  const { setFormStep } = useContext(SmartLoginActionsContext);

  return (
    <ODSGroup stacked spacing="xl">
      <div>
        <h5 data-testid="sso-link-success-heading">
          <FormattedMessage {...messages.heading} />
        </h5>
        <p data-testid="sso-link-success-body" className="mb-0">
          <FormattedMessage {...messages.body} />
        </p>
      </div>
      <MatchingAccountCard
        profile={profile}
        discoveredAccountDetails={discoveredAccountDetails}
      />
      <ODSButton
        color="primary"
        size="md"
        fullWidth
        data-testid="sso-link-success-continue"
        onClick={() => setFormStep(FormStepEnum.Login)}
      >
        <FormattedMessage {...messages.continue} />
      </ODSButton>
    </ODSGroup>
  );
}

export default SSOLinkSuccess;
